class ItemResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { contentApi }) {
        return (headers = {}) =>
            $resource(
                `${contentApi.url}/v1/items/:id`,
                { id: "@id" },
                {
                    get: {
                        method: "GET"
                    },
                    getMedias: {
                        method: "GET",
                        url: `${contentApi.url}/v1/items/:id/medias`,
                        isArray: true,
                        headers
                    },
                    createMedia: {
                        method: "POST",
                        url: `${contentApi.url}/v1/items/:id/medias`,
                        headers
                    },
                    update: {
                        method: "PATCH"
                    },
                    reset: {
                        method: "POST",
                        url: `${contentApi.url}/v1/items/:id/purge`
                    },
                    publish: {
                        method: "POST",
                        url: `${contentApi.url}/v1/items/:id/publish`,
                        headers
                    }
                }
            );
    }
}

class ItemTranslationsResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor($resource: ng.resource.IResourceService, { contentApi }) {
        return (_headers = {}) =>
            $resource(
                `${contentApi.url}/v1/items/:id`,
                { id: "@id" },
                {
                    translate: {
                        method: "PATCH",
                        url: `${contentApi.url}/v1/items/:id/translations`
                    }
                }
            );
    }
}

angular
    .module("thor.core.item.resource", [])
    .factory("itemResource", ItemResource)
    .factory("itemTranslationsResource", ItemTranslationsResource);
